export const theme = {
  white: '#fff',
  black: '#000',
  green: '#39CA31',
  blue: '#0E3182',
  lightBlue: '#47C8EE',
  paleBlue: '#406ac8',
};

export const spacing = {
  xs: 4, // 0.5x = 4px
  sm: 8, // 1x = 8px
  md: 16, // 2x = 16px
  lg: 24, // 3x = 24px
  xl: 32, // 4x = 32px
  xxl: 40, // 5x = 40px
  xxxl: 48, // 6x = 48px
  huge: 64, // 8x = 64px
  giant: 80, // 10x = 80px
  mega: 96, // 12x = 96px
};

export const space = (multiplier = 1) => `${8 * multiplier}px`;

export const fontSize = {
  xs: '12px', // 1.5x = 12px
  sm: '14px', // 1.75x = 14px
  base: '16px', // 2x = 16px
  lg: '20px', // 2.5x = 20px
  xl: '24px', // 3x = 24px
  xxl: '32px', // 4x = 32px
  xxxl: '40px', // 5x = 40px
  huge: '48px', // 6x = 48px
  giant: '56px', // 7x = 56px
  mega: '64px', // 8x = 64px
};

export const lineHeight = {
  tight: 1.2,
  base: 1.5,
  relaxed: 1.75,
  loose: 2,
};

export const borderRadius = {
  sm: '4px', // 0.5x = 4px
  base: '8px', // 1x = 8px
  md: '12px', // 1.5x = 12px
  lg: '16px', // 2x = 16px
  xl: '24px', // 3x = 24px
  full: '9999px',
};
